export default "__VITE_ASSET__Ci3yEo2E__"